"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApilogoFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.ApilogoFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("g", { clipPath: "url(#clip0_4062_1472)" },
                react_1.default.createElement("path", { d: "M53.2711 16.7225L2.96104 103.838C-4.4999 116.802 4.82628 133.011 19.8041 133.011H120.42C135.388 133.011 144.747 116.802 137.263 103.838L86.9526 16.7225C79.4684 3.75915 60.7554 3.75915 53.2711 16.7225Z", fill: "#F5BE08" }),
                react_1.default.createElement("path", { d: "M71.1768 44.2476L40.6895 96.4603H101.66L71.1768 44.2476Z", fill: "#2DCBDF" }),
                react_1.default.createElement("path", { d: "M84.1643 87.1484L54.2879 35.3881C51.8076 31.0917 51.1357 25.986 52.4199 21.1942C53.7041 16.4023 56.8392 12.3169 61.1356 9.83668C65.432 7.35642 70.5377 6.68448 75.3296 7.96869C80.1214 9.25289 84.2068 12.388 86.687 16.6844L116.563 68.4447C119.043 72.7411 119.715 77.8468 118.431 82.6387C117.147 87.4305 114.012 91.5159 109.715 93.9961C105.419 96.4764 100.313 97.1483 95.5218 95.8641C90.73 94.5799 86.6446 91.4448 84.1643 87.1484Z", fill: "#F43C7C" }),
                react_1.default.createElement("path", { d: "M53.8072 16.232L2.41989 105.236C-0.0110879 109.555 -0.640585 114.658 0.668054 119.438C1.97669 124.218 5.11784 128.289 9.4096 130.767C13.7014 133.245 18.7973 133.93 23.5912 132.674C28.3852 131.417 32.4901 128.321 35.0149 124.057L86.4022 35.0522C88.8331 30.7336 89.4626 25.6305 88.154 20.8506C86.8454 16.0707 83.7042 11.9999 79.4125 9.5218C75.1207 7.04376 70.0247 6.35851 65.2308 7.61481C60.4369 8.87111 56.332 11.9676 53.8072 16.232Z", fill: "#8355EC" })),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("clipPath", { id: "clip0_4062_1472" },
                    react_1.default.createElement("rect", { width: "140", height: "140", fill: "white" }))));
    },
    name: 'apilogo__filled',
    defaultColors: ['#2DCBDF', '#8355EC', '#F43C7C', '#F5BE08', 'white'],
    colorful: true,
    allPathData: [],
    width: '140',
    height: '140',
    viewBox: '0 0 140 140',
});
